import React from 'react';
import Page from '../components/Page';
import { Redirect } from 'react-router';
import StorageService from '../services/StorageService';
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from 'reactstrap';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';
import axios from 'axios';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import SiteForm from '../components/SiteForm';

class SitePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      confirmModal: false,
      selectedData: '',
      isEdit: false,
      siteId: '',
      siteList: [],
      redirect: false,
      loader: true,
      isLoading: true,
    };
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit:
        id != undefined || (id != null && action == 'EDIT') ? true : false,
      siteId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    });
  };

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      siteId: id,
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.getSiteList();
    }
  };

  siteTherma = id => {
    this.props.history.push({
      pathname: '/site/' + id + '/site-therma',
    });
  };

  activity = id => {
    this.props.history.push({
      pathname: '/site/' + id + '/activity',
    });
  };

  delete = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
      SiteID: this.state.siteId,
    };

    axios
      .post(url + ':3000/v1/site/delete', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Site deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.setState({ confirmModal: false });
        this.getSiteList();
      })
      .catch(error => {
        alert(error);
      });
  };

  getSiteList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const org = StorageService.getSession('selected_org');

    if (org === null) {
      this.setState({ isLoading: false });
      return;
    }

    const data = {
      session_key: user.session_key,
      CompanyID: org.CompanyID,
    };

    axios
      .post(url + ':3000/v1/site/get', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({
          siteList: result.data,
          isLoading: false,
        });
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    const org = StorageService.getSession('selected_org');

    // if (org.Features.length > 0) {
    //   let idx = org.Features.findIndex(el => el.Feature === 'Personnel');
    //   if (idx < 0) {
    //     this.setState({
    //       redirect: true,
    //     });
    //   }
    // }
    setTimeout(() => this.getSiteList(), 500);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }

    return (
      <Page
        className="SitePage"
        title="Site"
        breadcrumbs={[{ name: 'Site', active: true }]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <div className="text-right mb-4">
                  <Button
                    className="theme-button theme-button-primary"
                    onClick={this.toggle('ADD', null)}
                  >
                    Create
                  </Button>
                </div>

                <Table responsive hover className="ps-table tb-col-5">
                  <thead>
                    <tr>
                      <th>Site Name</th>
                      <th>Site Address</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.isLoading && (
                      <tr>
                        <td colSpan="3">
                          <div
                            style={{
                              minHeight: '100px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <Spinner animation="border" variant="primary" />
                          </div>
                        </td>
                      </tr>
                    )}

                    {!this.state.isLoading && this.state.siteList.length < 1 && (
                      <tr>
                        <td colSpan="3">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                              <span>
                                Click the 'Create' button to add new site
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.siteList.length > 0 &&
                      this.state.siteList.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.SiteName}</td>
                            <td>{item.SiteAddress}</td>
                            <td>
                              <div className="ps-action-button">
                                <Button
                                  className="theme-button theme-button-dark"
                                  onClick={() => this.siteTherma(item.SiteKey)}
                                >
                                  View
                                </Button>
                                <Button
                                  className="theme-button theme-button-primary"
                                  onClick={() => this.activity(item.SiteKey)}
                                >
                                  Activity
                                </Button>
                                <Button
                                  className="theme-button theme-button-secondary"
                                  onClick={this.toggle('EDIT', item.SiteID)}
                                >
                                  Edit
                                </Button>
                                <Button
                                  color="link"
                                  className="theme-button theme-button-primary-light"
                                  //onClick={() => this.delete(item.SiteID)}
                                  onClick={this.toggleConfirmModal(
                                    item.SiteName,
                                    item.SiteID,
                                  )}
                                >
                                  Delete
                                </Button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <SiteForm
            history={this.props.history}
            onToggleModal={this.toggle}
            closeModal={this.closeModal}
            data={this.state}
          />
        </Modal>

        <Modal
          isOpen={this.state.confirmModal}
          toggle={this.toggleConfirmModal()}
          className={this.props.className}
          centered
          style={{ fontSize: '0.85rem' }}
        >
          <ModalHeader toggle={this.toggleConfirmModal()}>
            Delete Site
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>
                  Are you sure you want to delete {this.state.selectedData} ?
                </p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              className="theme-button theme-button-secondary"
              onClick={this.toggleConfirmModal()}
            >
              Discard
            </Button>
            <Button
              className="theme-button theme-button-primary"
              onClick={() => this.delete()}
            >
              Confirm
            </Button>{' '}
          </ModalFooter>
        </Modal>
      </Page>
    );
  }
}
export default SitePage;
